import React from "react";
import CommonHeader from "./BlogHeader";

import BlogHeroSection from "./BlogHeroSection";
import BlogPostList from "./BlogPostList";
import FooterLinks from "../../components/LandingPage/FooterLinks";
import SeoMeta from "../SEO/SeoMeta"; // ✅ Import SEO

export default function BlogMainPage() {
  return (
    <div className="flex min-h-screen flex-col justify-between bg-black text-white">
      <SeoMeta
        title="Million2Trillion Blog — Latest Insights from the Global Financial Market"
        description="Read expert posts, updates, and market stories from Million2Trillion's verified global financial community. Stay informed, grow smarter."
        url="https://million2trillion.com/blog"
        keywords="Million2Trillion blog, market updates, trading insights, financial blog, global investing, M2T news"
        image="/assets/images/og-banner.png"
      />
      <CommonHeader />
      <main className="flex-grow">
        <BlogHeroSection />
        <div className="mx-auto mb-24 max-w-7xl px-4 py-16">
          <BlogPostList />
        </div>
        <FooterLinks />
      </main>
    </div>
  );
}
